import { StyledIcon } from 'src/components/foundations/foundations.styles';
import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const PageCover = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props) => (props.isOpen ? '100vw' : '0')};
  height: 100vh;
  background-color: #000000;
  opacity: ${(props) => (props.isOpen ? '0.7' : '0')};
  transition: opacity 0.3s
    ${(props) => (props.isOpen ? '' : ', width 0s linear 0.3s')};
  z-index: 3000;
`;

export const SlideOutStyled = styled.div<{ isOpen: boolean; $width?: string }>`
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  width: ${({ $width }) => $width ?? '660px'};
  overflow-y: auto;
  overflow-x: hidden;
  transition: transform 1s cubic-bezier(0.22, 1, 0.36, 1)
    ${(props) => (props.isOpen ? '0s' : '0.3s')};
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(100%)')};
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  z-index: 4000;
`;

const DEFAULT_HEADER_REVEAL_DELAY_MS = 650;

export const SlideOutHeader = styled.div<{
  isOpen: boolean;
  $width?: string;
  $headerRevealDelayMs?: number;
}>`
  display: flex;
  align-items: center;
  width: ${({ $width }) => $width ?? '620px'};
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  transition: opacity 0.3s
    ${(props) =>
      props.isOpen
        ? `${props.$headerRevealDelayMs ?? DEFAULT_HEADER_REVEAL_DELAY_MS}ms`
        : '0s'};
  flex-direction: column;
`;

export const SlideOutMainHeader = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  width: 100%;
  padding: 20px;
`;

export const SlideOutTitle = styled.h3`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.body)}
  font-weight: 600;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0 16px 0 0;
  width: 100%;
  text-align: center;
`;

export const StyledCloseIcon = styled(StyledIcon)`
  cursor: pointer;
`;

const DEFAULT_BODY_REVEAL_DELAY_MS = 650;

export const SlideOutBody = styled.div<{
  isOpen: boolean;
  $width?: string;
  $bodyRevealDelayMs?: number;
}>`
  flex-grow: 2;
  overflow-x: hidden;
  overflow-y: auto;
  margin: 0 20px;
  width: ${({ $width }) => $width ?? '620px'};
  padding-bottom: 20px;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  transition: opacity 0.3s
    ${(props) =>
      props.isOpen
        ? `${props.$bodyRevealDelayMs ?? DEFAULT_BODY_REVEAL_DELAY_MS}ms`
        : '0s'};
`;

export const SlideOutFooter = styled.div<{
  hasOneButton: boolean;
  isOpen: boolean;
}>`
  display: flex;
  justify-content: ${(props) =>
    props.hasOneButton ? 'flex-end' : 'space-between'};
  width: 620px;
  margin: 20px;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  transition: opacity 0.3s ${(props) => (props.isOpen ? '0.65s' : '0s')};
`;

export const SlideOutSubTitle = styled.div`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  width: 150px;
  position: absolute;
  right: -20px;

  & > span {
    font-weight: 600;
  }
`;

export const DividerContainer = styled.div`
  padding: 0 20px;
`;
